export default __webpack_public_path__ + "static/media/hub-nav-guide.58e1ced0.svg";